import { Locale } from '../types/locale';

export function detectBrowserLocale(lang?: string): Locale {
  const language = lang ?? '';
  if (language.startsWith('zh')) return Locale.ZH_CN;
  return Locale.EN_US;
}
